import { NOTIF_SEND, NOTIF_DISMISS, NOTIF_CLEAR } from '../actions/notifications';
import { StorageKeys } from '../helpers/localStorage';

/**
 * Fetch default state from localStorage
 */
const getDefaultState = () => {
  const items = localStorage.getItem(StorageKeys.notifications);
  if (items) {
    try {
      return JSON.parse(items);
    } catch (err) {
      console.error('Could not parse current');
      return [];
    }
  }
  return [];
};


export default function notifs(domain: any[] = getDefaultState(), action: any) {
  if (!action || !action.type) {return domain;}

  switch (action.type) {
  case NOTIF_SEND:
    return [action.payload, ...domain.filter(({ id }: any) => id !== action.payload.id)];
  case NOTIF_DISMISS:
    return domain.filter((notif: any) =>
      notif.id !== action.payload
    );
  case NOTIF_CLEAR:
    return [];
  default:
    return domain;
  }
}
